import React, { FC } from "react";
import { Chip as MuiChip, ChipProps } from "@mui/material";

const Chip: FC<ChipProps> = (props) => {
  return <MuiChip {...props} />;
};

export default Chip;
